module.exports = __webpack_public_path__ + "img/KSC08674.58e948db.jpg";